// extracted by mini-css-extract-plugin
export default {"body_open":"body_body_open__7t+9n","body_close":"body_body_close__bceZD"};